import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "card-header border-0 pt-5 mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "px-2" }, "Encode BIBO Endorser", -1)
const _hoisted_5 = {
  type: "button",
  ref: "registerNewBiboButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_register_account_modal_bibo`
}
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Sponsor"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Action")
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "btn btn-primary er fs-6 px-8 py-2",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_modal_bibo_reposition`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_RegisterEndorserModalBibo = _resolveComponent("RegisterEndorserModalBibo")
  const _component_BIBO_REPOSITION_ENDORSER = _resolveComponent("BIBO_REPOSITION_ENDORSER")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            type: "button",
            class: "btn btn-success px-2 py-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.registerNewEndorser()))
          }, [
            _hoisted_4
          ]),
          _withDirectives(_createVNode("button", _hoisted_5, " Click here ", 512), [
            [_vShow, false]
          ]),
          _createVNode(_component_RegisterEndorserModalBibo, {
            key: _ctx.modalkey,
            slotdata: _ctx.slotdata
          }, null, 8, ["slotdata"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("table", _hoisted_8, [
              _hoisted_9,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, "   " + _toDisplayString(item.recid), 1),
                    _createVNode("td", null, _toDisplayString(item.usid), 1),
                    _createVNode("td", null, _toDisplayString(item.usidname), 1),
                    _createVNode("td", null, _toDisplayString(item.spname) + " (" + _toDisplayString(item.spid) + ")", 1),
                    _createVNode("td", null, [
                      (!_ctx.isOverriden)
                        ? (_openBlock(), _createBlock("button", _hoisted_10, " REPOSITION "))
                        : _createCommentVNode("", true),
                      _createVNode(_component_BIBO_REPOSITION_ENDORSER, {
                        key: index,
                        usid: item.usid
                      }, null, 8, ["usid"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}